import { Injectable } from '@angular/core';
import { Documento } from '../models/documento';
import { Router } from '@angular/router';
import { Cliente } from '../models/cliente';
import { DocumentAgregar } from '../models/document-agregar';
import { BehaviorSubject, Observable } from 'rxjs';

export const ORIGEN_PANTALLA_VENTA = 'venta';
export const ORIGEN_PANTALLA_CUENTAS_POR_COBRAR = 'cuentasPorCobrar';
export const ORIGEN_PANTALLA_PAGOS = 'pagos';

@Injectable()
export class PagoVentaService {

  private ventasPorPagar: Documento[] = [];
  private ventaAAgregar: DocumentAgregar;
  private cliente: Cliente = null;
  private origen: string = null;
  private seModificaVenta = false;

  constructor(private router: Router) {
  }

  /**
   * @param ventas Ventas que se pagaran
   * @param cliente Cliente a quien se le abonara el pago
   */
  pagarVentas(ventas: Documento[], cliente: Cliente, esTabPagos = false) {
    this.cliente = cliente;
    this.ventasPorPagar = ventas;

    if (this.router.url.search('historial-pagos') && !esTabPagos) {
      this.origen = ORIGEN_PANTALLA_CUENTAS_POR_COBRAR;
    } else if (esTabPagos) {
      this.origen = ORIGEN_PANTALLA_PAGOS;
    } else {
      // TODO: Error, pantalla no valida
    }
    this.router.navigate(['/app/pago-venta']);
  }

  pagarVenta(ventaAAgregar: DocumentAgregar, cliente: Cliente) {
    this.cliente = cliente;
    this.ventaAAgregar = ventaAAgregar;
    
    this.ventasPorPagar.push(ventaAAgregar.Venta);

    if (this.router.url.search('venta')) {
      this.origen = ORIGEN_PANTALLA_VENTA;
    } else {
      // TODO: Error, pantalla no valida
    }
    if(ventaAAgregar.NOMENCLATURA =="COM" ){
      this.router.navigate(['/app/pago-compra/:parametro']);
    }else{
    this.router.navigate(['/app/pago-venta']);
   } 
  }

  obtenerVentasPorPagar(): any[] {
    return this.ventasPorPagar;
  }

  obtenerVentaAAgregar(): DocumentAgregar {
    return this.ventaAAgregar;
  }

  obtenerCliente(): Cliente {
    return this.cliente;
  }

  obtenerOrigen() {
    return this.origen;
  }

  restablecerValores() {
    this.origen = null;
    this.cliente = null;
    this.ventasPorPagar = [];
  }

  seModificaraVentaPorPagar(seModificara: boolean) {
    this.seModificaVenta = seModificara;
  }

  seModificaraVenta(): boolean {
    return this.seModificaVenta;
  }

}



// WEBPACK FOOTER //
// ./src/app/pago-venta/pago-venta.service.ts